/**
 * Calculates the total carbohydrate content of a product based on its ingredients.
 */
export function calculateTotalCarbs(product: Product): number | null {
  const { ingredients } = product;
  const hasOnlyInvalidValues = ingredients.every(checkIfHasInvalidValues);

  if (hasOnlyInvalidValues) {
    return null;
  }

  const totalCarbs = [...ingredients].reduce(addCarbs, 0);

  return Math.round(totalCarbs);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfHasInvalidValues(ingredient: Ingredient) {
  return typeof ingredient.totalCarbsG !== 'number';
}

function addCarbs(total: number, ingredient: Ingredient): number {
  const carbs =
    typeof ingredient.totalCarbsG === 'number' ? ingredient.totalCarbsG : 0;

  return total + carbs;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Product = {
  ingredients: Ingredient[] | readonly Ingredient[];
};

type Ingredient = { totalCarbsG: number | null };
